import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Wrapper, Title, Row } from './styled';
import CheckboxField from './CheckboxField';
import { useDispatch, useSelector } from 'react-redux';
import { selectMaxSeverity, selectMinSeverity, selectResolveHost } from 'store/ManageEditCreate/selectors';
import { setResolveHost, setSeverityRange } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import SeverityRange from 'Common/Components/SeverityRange';
import { STEP_VALUES } from 'Common/Components/SeverityRange/constants';

const AdvancedOptions = ({ showSeverityRange }) => {
  const resolveHost = useSelector(selectResolveHost);
  const minSeverity = useSelector(selectMinSeverity);
  const maxSeverity = useSelector(selectMaxSeverity);
  const dispatch = useDispatch();
  const intl = useIntl();
  const resolveHostLabel = intl.formatMessage({ id: 'importFileCreationModal.advancedOptions.resolveHost' });

  const handleChangeSeverity = (range) => {
    const min = STEP_VALUES.find((sev) => sev.value === range[0]);
    const max = STEP_VALUES.find((sev) => sev.value === range[1]);
    dispatch(setSeverityRange({
      min: { value: min.value, severity: min.parsedSeverity },
      max: { value: max.value, severity: max.parsedSeverity }
    }));
  };

  return (
    <Wrapper>
      <Row>
        <Title children={ intl.formatMessage({ id: 'importFileCreationModal.advancedOptions.title' }) } />
        <CheckboxField defaultValue={ resolveHost } label={ resolveHostLabel } onChange={ (checked) => dispatch(setResolveHost(checked)) } />
      </Row>
      { showSeverityRange &&
        <SeverityRange
          defaultMin= { minSeverity.value }
          defaultMax={ maxSeverity.value }
          onChange={ handleChangeSeverity }
        />
      }
    </Wrapper>
  );
};

AdvancedOptions.defaultProps = {
  showSeverityRange: true
};

AdvancedOptions.propTypes = {
  showSeverityRange: PropTypes.bool
};

export default AdvancedOptions;
